module.exports = __webpack_public_path__ + "static/media/15.c2c4a6f8.mp3";